import { useEffect, useRef, useState } from 'react';

export default function useThrottledValue<T>(value: T, intervalMs: number): T {
  const [throttled, setThrottled] = useState<T>(value);
  const lastTimeRef = useRef<number>(0);
  const timeoutRef = useRef<number | null>(null);

  useEffect(() => {
    const now = Date.now();
    const elapsed = now - lastTimeRef.current;
    if (elapsed >= intervalMs) {
      lastTimeRef.current = now;
      setThrottled(value);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    } else {
      const remaining = intervalMs - elapsed;
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = window.setTimeout(() => {
        lastTimeRef.current = Date.now();
        setThrottled(value);
        timeoutRef.current = null;
      }, remaining);
    }
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
  }, [value, intervalMs]);

  return throttled;
}

